import { render, staticRenderFns } from "./DashboardTotalsCard.vue?vue&type=template&id=33f85f27&"
import script from "./DashboardTotalsCard.vue?vue&type=script&lang=js&"
export * from "./DashboardTotalsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports